module.exports = __webpack_public_path__ + "img/me.4039d130.png";